module.exports = __webpack_public_path__ + "static/media/car2.deafb9a3.png";